/* TODO: Currently, this module contains both the visualization component, 
which now renders a visual of the tape, tape contents, head, and 
state, and the source-code editing component, which allows the 
user to edit the source code fed to the Turing machine.

This module should be refactored into at least two components:
  1. turing_viz
  2. code_editor
*/

import React from "react";
import "./turing_viz.css";

const TuringViz = ({
  machineState,
  takeStep,
  setMachineFromCode,
  sourceCode,
  setLastChanger,
  setSourceCode,
}) => {
  return (
    <React.Fragment>
      <div className="border border-secondary rounded machine-state">
        <h3>
          <span className="badge m-2">State:</span>
        </h3>
        <center>
          <h4>
            <span className="badge border border-secondary badge-light">
              {machineState.state}
            </span>
          </h4>
        </center>
        <h3>
          <span className="badge m-2">Tape:</span>
          <div className="tape border boder-dark rounded bg-light m-2">
            <div className="flex-row">
              <div className="text-right">{machineState.left}</div>
              <span>
                <b>^{machineState.head}</b>
              </span>
              <div>{machineState.right}</div>
            </div>
          </div>
        </h3>
      </div>
      <button
        id="stepButton"
        className="btn btn-primary m-2 disable-dbl-tap-zoom"
        disabled={machineState.halted}
        onClick={() => takeStep()}
      >
        Step
      </button>
      <button
        id="resetButton disable-dbl-tap-zoom"
        className="btn btn-secondary m-2"
        onClick={() => setMachineFromCode()}
      >
        Reset
      </button>
      <h3>
        <span className="badge m-2 machine-state">Code:</span>
      </h3>
      <div className="machine-state rounded">
        <textarea
          className="form-control bg-light"
          rows={8}
          value={sourceCode}
          onChange={(event) => {
            setLastChanger(null);
            setSourceCode(event.target.value);
          }}
        ></textarea>
      </div>
    </React.Fragment>
  );
};

export default TuringViz;
